import { render, staticRenderFns } from "./org-add-or-update-child.vue?vue&type=template&id=b212572a"
import script from "./org-add-or-update-child.vue?vue&type=script&lang=js"
export * from "./org-add-or-update-child.vue?vue&type=script&lang=js"
import style0 from "./org-add-or-update-child.vue?vue&type=style&index=0&id=b212572a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports